import { MagpieConnection } from 'magpie-lib/connection';
import { tourTopic } from './tour.topic';
import { tourMessages } from './tour.messages';
export const stopTour = (tourId, timeoutMs = 5000) => {
  const message = tourMessages.stopTour.create({
    tourId
  });
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error(`Stop tour request timed out after ${timeoutMs}ms`));
    }, timeoutMs);
    MagpieConnection.get().useTopic(tourTopic).publish(message, {
      onReply: reply => {
        clearTimeout(timeoutId);
        if (reply.payload.status === 'success') {
          resolve();
        } else {
          reject(new Error(`Failed to stop tour: ${reply.payload.status}`));
        }
      }
    });
  });
};